import { useCallback } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';
import FileExport from '@gef-ui/material-icons/FileExport';

import { ComponentLoader } from 'components';
import { MPU_TASK_SUBORDINATE_REPORT } from 'features/common/acl/constants';
import { urls } from 'features/common/fetch/constants';
import { getHasPPZSubordinates } from 'features/views/user/selectors';
import { getContextUser } from 'features/views/userContext/selectors';
import { reportSubordinates } from 'features/views/usersSubordinate/actions';

export const ActionButtons = () => {
	const dispatch = useDispatch();

	const mainUserHasPPZSubordinates = useSelector(getHasPPZSubordinates);
	const contextUser = useSelector(getContextUser);
	const hasPPZSubordinates = contextUser ? contextUser.hasPPZSubordinates : mainUserHasPPZSubordinates;

	const handleReport = useCallback(() => {
		dispatch(reportSubordinates());
	}, [dispatch]);

	return (
		<AccessControl accessLevel={MPU_TASK_SUBORDINATE_REPORT}>
			{hasPPZSubordinates && (
				<ComponentLoader fetchStorePath={urls.unfinishedTaskReport} ignoreErrors>
					<Button variant="text" size="small" startIcon={<FileExport />} onClick={handleReport}>
						{getLabelMessage('subordinateUsers:reportButton')}
					</Button>
				</ComponentLoader>
			)}
		</AccessControl>
	);
};

export default ActionButtons;
